"use client"
import { z } from "zod"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"

import { Form, FormField, FormItem } from "@/components/ui/form"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { useSignIn } from "@/hooks/mutations/auth/useSignIn"

const AuthForm = () => {
  const { triggerSignIn, isPending } = useSignIn()
  const formSchema = z.object({
    login: z.string().min(3, "Login kamida 3 ta belgidan iborat bo'lishi kerak"),
    password: z.string().min(3, "Parol kamida 3 ta belgidan iborat bo'lishi kerak"),
  })
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      login: "",
      password: "",
    },
  })

  const onSubmit = (values: z.infer<typeof formSchema>) => {
    triggerSignIn(values)
  }

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-5">
          <FormField
            name="login"
            control={form.control}
            render={({ field }) => (
              <FormItem className="space-y-1.5">
                <Label htmlFor="login" className="text-[13px] font-medium text-slate-700">
                  Login
                </Label>
                <Input
                  id="login"
                  type="text"
                  placeholder="998908717304"
                  {...field}
                  className="h-11 bg-primary/5 border-transparent focus:bg-white focus:border-primary focus:ring-1 focus:ring-primary rounded-xl text-[14px]"
                />
              </FormItem>
            )}
          />
          <FormField
            name="password"
            control={form.control}
            render={({ field }) => (
              <FormItem className="space-y-1.5">
                <Label htmlFor="password" className="text-[13px] font-medium text-slate-700">
                  Parol
                </Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="••••"
                  {...field}
                  className="h-11 bg-primary/5 border-transparent focus:bg-white focus:border-primary focus:ring-1 focus:ring-primary rounded-xl text-[14px]"
                />
              </FormItem>
            )}
          />
          <Button
            type="submit"
            disabled={isPending}
            className="w-full h-11 bg-primary hover:opacity-90 text-white font-medium rounded-xl transition-all shadow-md hover:shadow-lg mt-2"
          >
            {isPending ? "Logging in..." : "Sign In"}
          </Button>
        </form>
      </Form>
    </>
  )
}

export default AuthForm
